<div class="py-8" *ngIf="downloadFile">
  <h2 class="text-primary poppins-medium pt-8 text-center md:text-left">Output Files</h2>
  <div class="text-sm italic text-slate-400 text-center md:text-left">* Files will get deleted within five minutes</div>
  <div class="flex flex-col items-center">
    <div class="flex flex-col w-full bg-[#FAF9FF] rounded-2xl shadow-md">
      <div *ngFor="let file of fileData; let i = index;">
        <div class="flex flex-col md:flex-row justify-between items-center p-4">
          <div class="flex items-center mb-4 md:mb-0">
            <img src="../../../../assets/images/output-excel.png" alt="Excel Icon" class="h-12 w-12" />
            <div class="px-5 poppins-medium text-slate-600">
              <span class="truncate block max-w-[150px] md:max-w-[250px] lg:max-w-[400px]" [title]="file.name">
                {{ file.name }}
              </span>
              <small class="poppins-regular text-slate-500 block">{{ formatFileSize(file.size) }}</small>
            </div>
          </div>
          <p-button
            label="Download"
            icon="pi pi-download"
            pTooltip="Download File"
            [loading]="file.loading"
            [disabled]="file.expired || isExpired"
            severity="success"
            tooltipPosition="bottom"
            outlined="true"
            size="small"
            (onClick)="onDownload(file, i)"
          />
          <ng-template #expired>
            <a download pTooltip="Link Expired" tooltipPosition="bottom" class="cursor-not-allowed">
              <p-button label="Download" icon="pi pi-download" outlined="true" size="small" [disabled]="true" severity="contrast" />
            </a>
          </ng-template>
        </div>
        <p-divider *ngIf="i !== fileData.length - 1" />
      </div>
      <!-- <div *ngIf="isExpired" class="px-5 poppins-medium">
        <div class="flex items-center gap-6">
          <img src="../../../../assets/images/warning.gif" alt="File Expired Icon" height="70" />
          <div>File Download Link has Expired!</div>
        </div>
      </div> -->
    </div>
  </div>
</div>